export const API_BASE_URL = "https://api.smartshakevending.com";
//export const API_BASE_URL = "http://localhost:5001";
//export const API_BASE_URL = "http://64.227.186.207:5001";